import { apiHelpers } from './api';
import { Employee, ApiResponse, EmployeeFormData } from '../types/models';
import { convertToUtcDate } from '../utils/dateUtils';

export class EmployeeService {
  // Получить всех сотрудников
  static async getAll(): Promise<ApiResponse<Employee[]>> {
    return apiHelpers.get<Employee[]>(`/Employee/GetAll`);
  }

  // Получить сотрудника по ID
  static async getById(id: number): Promise<ApiResponse<Employee>> {
    return apiHelpers.get<Employee>(`/Employee/Get?id=${id}`);
  }

  // Получить сотрудников по отделу
  static async getByDepartment(departmentId: number): Promise<ApiResponse<Employee[]>> {
    return apiHelpers.get<Employee[]>(`/Employee/GetByDepartment?departmentId=${departmentId}`);
  }

  // Создать нового сотрудника
  static async create(data: EmployeeFormData): Promise<ApiResponse<Employee>> {
    const utcData = {
      ...data,
      birthday: data.birthday ? convertToUtcDate(data.birthday) : undefined,
    };
    return apiHelpers.post<Employee>('/Employee/Create', utcData);
  }

  // Обновить сотрудника
  static async update(id: number, data: EmployeeFormData & { id: number }): Promise<ApiResponse<void>> {
    const utcData = {
      ...data,
      birthday: data.birthday ? convertToUtcDate(data.birthday) : undefined,
    };
    return apiHelpers.put<void>(`/Employee/Update/${id}`, utcData);
  }

  // Поиск сотрудников по имени
  static async search(query: string): Promise<ApiResponse<Employee[]>> {
    return apiHelpers.get<Employee[]>(`/Employee/Search?query=${encodeURIComponent(query)}`);
  }

  // Удалить сотрудника
  static async delete(id: number): Promise<ApiResponse<void>> {
    return apiHelpers.delete<void>(`/Employee/Delete/${id}`);
  }
}

